function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './CarouselSlider.css';

var CarouselSlider = function (_Component) {
  _inherits(CarouselSlider, _Component);

  function CarouselSlider(props) {
    _classCallCheck(this, CarouselSlider);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      currentSlide: 1
    };
    _this.slidingManner = {
      //currentSlide: 1,
      slidesTotalWidth: 0,
      initialMovement: 0,
      movement: 0,
      direction: 1,
      cycle: 0,
      sliding: false,
      slideOrders: [[], [], []]
    };
    _this.dragEvent = {
      startPoint: 0,
      dragging: false,
      deltaX: 0,
      thrershold: 0,
      disableDragImage: function () {
        var transparent = new Image();
        transparent.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
        return transparent;
      }()
    };
    _this.calculateSlidesOrder = _this.calculateSlidesOrder.bind(_this);
    _this.itemsReorder = _this.itemsReorder.bind(_this);
    _this.movementReset = _this.movementReset.bind(_this);
    _this.loadedCnt = 0;
    _this.imgsWidth = {};
    _this.mannerSetting = {
      autoSliding: false,
      //{interval: }
      circular: true,
      duration: "0.5s"
    };
    _this.mannerSetting = _this.handleMannerSetting();
    _this.accEleSetting = {
      flag: false,
      button: true,
      dots: true
    };
    _this.accEleSetting = _this.handleAccEleSetting();
    _this.defaultDotStyle = {
      display: "inline-block",
      verticalAlign: "middle",
      margin: "0 5px",
      background: "#dbdbdb",
      height: "10px",
      width: "10px",
      borderRadius: "50%"
    };
    _this.defaultCurrDotStyle = {
      display: "inline-block",
      verticalAlign: "middle",
      margin: "0 5px",
      background: "#3897f0",
      height: "12px",
      width: "12px",
      borderRadius: "50%"
    };
    _this.defaultSliderBoxStyle = {
      height: "400px",
      width: "90%",
      background: "#EEEEEE",
      border: "none"
    };
    _this.defaultSlideConStyle = {
      height: "80%"
    };
    _this.defaultItemsStyle = {
      padding: "3px",
      background: "#FAFAFA",
      margin: "0px 40px" // ,minWidth: "100px" 

    };
    _this.buttonManner = {
      hoverEvent: false
    };
    _this.defaultButtonSetStyle = {//no style
    };
    _this.defaultDotsSetStyle = {
      margin: "15px auto"
    };
    _this.defaultButtonIconStyle = {
      color: "white",
      background: "#757575",
      height: "30px",
      width: "30px",
      margin: "10px",
      fontSize: "20px",
      borderRadius: "2px",
      border: "none"
    };
    _this.defaultBtnPosition = {
      "top-left": true,

      /**/
      "top-right": false,
      "middle-inside": false,
      "middle-outside": false,
      "bottom-right": false,
      "bottom-left": false,
      "bottom-beneath": false
    };
    _this.defaultDotsPosition = {
      "beneath": true,
      "top": false,

      /**/
      "bottom": false
    };
    _this.itemsMargin = _this.props.itemsStyle ? _this.props.itemsStyle.margin ? parseInt(_this.props.itemsStyle.margin.split(' ')[1].replace('px', '')) : parseInt(_this.defaultItemsStyle.margin.split(' ')[1].replace('px', '')) : parseInt(_this.defaultItemsStyle.margin.split(' ')[1].replace('px', ''));
    _this.slideType = _this.props.slideItems ? 'prop' : _this.props.slideCpnts ? 'cpnt' : null;
    _this.slideCnt = _this.slideType === 'prop' ? _this.props.slideItems.length : _this.slideType === 'cpnt' ? _this.props.slideCpnts.length : 0;
    _this.slideEls = _this.slideType === 'prop' ? _this.props.slideItems : _this.slideType === 'cpnt' ? _this.props.slideCpnts : null;
    _this.touchEvent = {
      touchMovement: 0,
      touchStartX: 0,
      beingTouched: false
    };
    _this.imgLoaded = _this.imgLoaded.bind(_this);
    _this.nonImgLoaded = _this.nonImgLoaded.bind(_this);
    _this.slideItemHandler = _this.slideItemHandler.bind(_this);
    _this.initialSlideCon = _this.initialSlideCon.bind(_this);
    _this.calMovement = _this.calMovement.bind(_this);
    _this.autoSliding = _this.autoSliding.bind(_this);
    _this.handleMannerSetting = _this.handleMannerSetting.bind(_this);
    _this.handleAccEleSetting = _this.handleAccEleSetting.bind(_this); // this.handleBubbling = this.handleBubbling.bind(this);

    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
    _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
    _this.handleButtonClick = _this.handleButtonClick.bind(_this);
    _this.handleDragStart = _this.handleDragStart.bind(_this);
    _this.handleDragStop = _this.handleDragStop.bind(_this);
    _this.handleDragOver = _this.handleDragOver.bind(_this);
    _this.setSliderBoxStyles = _this.setSliderBoxStyles.bind(_this);
    _this.setItemsStyle = _this.setItemsStyle.bind(_this);
    _this.setSlideConHeight = _this.setSlideConHeight.bind(_this);
    _this.setDotStyle = _this.setDotStyle.bind(_this);
    _this.setCurrentDotStyle = _this.setCurrentDotStyle.bind(_this);
    _this.detectButtonPosition = _this.detectButtonPosition.bind(_this);
    _this.detectDotsPosition = _this.detectDotsPosition.bind(_this);
    _this.allocateDotsSet = _this.allocateDotsSet.bind(_this);
    _this.allocateButtonSet = _this.allocateButtonSet.bind(_this);
    _this.setLeftButtonStyle = _this.setLeftButtonStyle.bind(_this);
    _this.setHoverEvent = _this.setHoverEvent.bind(_this);

    _this.calculateSlidesOrder();

    return _this;
  }

  CarouselSlider.prototype.componentDidMount = function componentDidMount() {
    this.dragEvent.threshold = this.refs.sliderBox.offsetWidth > 100 ? this.refs.sliderBox.offsetWidth / 5 : 50;
  };

  CarouselSlider.prototype.componentWillUnmount = function componentWillUnmount() {
    clearInterval(this.autoSlidingTimer);
  };

  CarouselSlider.prototype.handleMannerSetting = function handleMannerSetting() {
    if (this.props.manner) {
      return Object.assign({}, this.mannerSetting, this.props.manner);
    } else {
      return this.mannerSetting;
    }
  };

  CarouselSlider.prototype.handleAccEleSetting = function handleAccEleSetting() {
    if (this.props.accEle) {
      return Object.assign({}, this.accEleSetting, this.props.accEle);
    } else {
      return this.accEleSetting;
    }
  };

  CarouselSlider.prototype.handleBubbling = function handleBubbling(e) {
    e.stopPropagation();
  };

  CarouselSlider.prototype.calculateSlidesOrder = function calculateSlidesOrder() {
    var order = [];
    var former = [];
    var latter = [];

    for (var i = -1 * this.slideCnt; i <= this.slideCnt * 2; i++) {
      if (i !== 0) {
        order.push(i);
      }
    }

    this.slidingManner.slideOrders[0] = order;

    for (var _i = 0; _i < order.length; _i++) {
      if (_i < this.slideCnt * 2) {
        latter.push(order[_i]);
      } else {
        former.push(order[_i]);
      }
    }

    this.slidingManner.slideOrders[1] = former.concat(latter);
    former = [];
    latter = [];

    for (var _i2 = 0; _i2 < order.length; _i2++) {
      if (_i2 < this.slideCnt) {
        latter.push(order[_i2]);
      } else {
        former.push(order[_i2]);
      }
    }

    this.slidingManner.slideOrders[2] = former.concat(latter);
  };

  CarouselSlider.prototype.mobileDetect = function mobileDetect() {
    if (/Mobi|Tablet|iPad|iPhone/.test(navigator.userAgent)) {
      return true;
    } else {
      return false;
    }
  };

  CarouselSlider.prototype.nonImgLoaded = function nonImgLoaded(index) {
    var refIndex = 'ref' + index;

    if (this.refs[refIndex]) {
      var customStyle = this.setItemsStyle();
      var targetItem = this.refs[refIndex];

      for (var key in customStyle) {
        targetItem.style[key] = customStyle[key];
      }

      this.loadedCnt += 1;
      this.imgsWidth[index] = targetItem.offsetWidth;

      if (!this.mannerSetting.circular && index === 1 || this.mannerSetting.circular && this.slideCnt === 1) {
        this.initialSlideCon();
      }

      if (this.mannerSetting.circular && this.loadedCnt === this.slideCnt * 3) {
        this.initialSlideCon();
      }
    }
  };

  CarouselSlider.prototype.imgLoaded = function imgLoaded(index) {
    var refIndex = 'ref' + index;

    if (this.refs[refIndex]) {
      var ratio = 0;
      var adjustWidth = 0;
      var adjustHeight = 0;
      var customStyle = this.setItemsStyle();
      var targetItem = this.refs[refIndex];

      if (targetItem.offsetWidth >= this.refs.sliderBox.offsetWidth) {
        ratio = targetItem.offsetHeight / targetItem.offsetWidth; // if (targetItem.offsetWidth > targetItem.offsetHeight) {

        adjustWidth = this.refs.sliderBox.offsetWidth - this.itemsMargin * 2;
        adjustHeight = adjustWidth * ratio; // }

        customStyle.height = adjustHeight + 'px';
        customStyle.width = adjustWidth + 'px';
      }

      for (var key in customStyle) {
        targetItem.style[key] = customStyle[key];
      }

      this.loadedCnt += 1;
      this.imgsWidth[index] = targetItem.offsetWidth;

      if (!this.mannerSetting.circular && index === 1 || this.mannerSetting.circular && this.slideCnt === 1) {
        this.initialSlideCon();
      }

      if (this.mannerSetting.circular && this.loadedCnt === this.slideCnt * 3) {
        this.initialSlideCon();
      }
    }
  };

  CarouselSlider.prototype.slideItemHandler = function slideItemHandler(slideEl, index) {
    var _this2 = this;

    switch (this.slideType) {
      case 'prop':
        var imgElement = slideEl.imgSrc ? React.createElement('img', {
          src: slideEl.imgSrc
        }) : React.createElement('img', {
          src: slideEl.imgSrc
        });
        var desElement = slideEl.des ? React.createElement('p', {
          style: this.setTextBoxStyle()
        }, slideEl.des) : null;
        return React.createElement('div', {
          className: 'itemWrapper',
          style: {
            order: index
          },
          onError: function onError() {
            return _this2.nonImgLoaded(index);
          },
          onLoad: function onLoad() {
            return _this2.imgLoaded(index);
          },
          onClick: this.handleBubbling,
          ref: 'ref' + index,
          key: 'ref' + index
        }, imgElement, desElement);
        break;

      case 'cpnt':
        return React.createElement('div', {
          className: 'itemWrapper',
          style: {
            order: index
          },
          onError: function onError() {
            return _this2.nonImgLoaded(index);
          },
          onLoad: function onLoad() {
            return _this2.imgLoaded(index);
          },
          onClick: this.handleBubbling,
          ref: "ref" + index,
          key: "ref" + index
        }, slideEl);
        break;
    }
  };

  CarouselSlider.prototype.initialSlideCon = function initialSlideCon() {
    var _this3 = this;

    var slideCon = this.refs.slideCon;
    slideCon.addEventListener('transitionend', function () {
      _this3.slidingManner.sliding = false;
    });

    if (this.mannerSetting.circular && this.slideCnt !== 1) {
      var sum = 0;

      for (var i = 1; i < this.slideCnt + 1; i++) {
        sum += parseInt(this.imgsWidth[i]);
      }

      this.slidingManner.slidesTotalWidth = sum + this.slideCnt * this.itemsMargin * 2;
      this.slidingManner.initialMovement = this.slidingManner.slidesTotalWidth - (this.refs.sliderBox.offsetWidth - (this.imgsWidth[1] + this.itemsMargin * 2)) / 2;
    } else {
      this.refs.sflag.style.flexBasis = this.refs.sliderBox.offsetWidth + 'px';
      this.refs.eflag.style.flexBasis = this.refs.sliderBox.offsetWidth + 'px';
      slideCon.style.transition = 'transform ' + this.mannerSetting.duration + ' ease';
      this.slidingManner.initialMovement = (this.refs.sliderBox.offsetWidth - this.imgsWidth[1]) / 2 + this.itemsMargin + this.imgsWidth[1];
    } // slideCon.style.transition = 'transform ' + this.mannerSetting.duration + ' ease';


    slideCon.style.transform = 'translateX(-' + this.slidingManner.initialMovement + 'px)';
    this.slidingManner.movement = this.slidingManner.movement + this.slidingManner.initialMovement;
    this.autoSliding();
  };

  CarouselSlider.prototype.autoSliding = function autoSliding() {
    var _this4 = this;

    if (this.mannerSetting.autoSliding && this.slideCnt !== 1) {
      var seconds = this.mannerSetting.autoSliding.interval.slice(0, -1);
      var milliseconds = parseInt(seconds) * 1000;

      if (this.mannerSetting.circular) {
        this.autoSlidingTimer = setInterval(function () {
          if (!_this4.slidingManner.sliding) {
            _this4.moveSlide(_this4.slidingManner.direction);
          }
        }, milliseconds);
      } else {
        this.autoSlidingTimer = setInterval(function () {
          if (_this4.state.currentSlide === _this4.slideCnt) {
            if (!_this4.slidingManner.sliding) {
              _this4.slidingManner.direction = -1;

              _this4.moveSlide(_this4.slidingManner.direction);
            }
          } else if (_this4.state.currentSlide === 1) {
            if (!_this4.slidingManner.sliding) {
              _this4.slidingManner.direction = 1;

              _this4.moveSlide(_this4.slidingManner.direction);
            }
          } else {
            if (!_this4.slidingManner.sliding) {
              _this4.moveSlide(_this4.slidingManner.direction);
            }
          }
        }, milliseconds);
      }
    }
  };

  CarouselSlider.prototype.itemsReorder = function itemsReorder() {
    for (var i = 0; i < this.slideCnt * 3; i++) {
      if (i < this.slideCnt) {
        this.refs['ref' + (i - this.slideCnt)].style.order = this.slidingManner.slideOrders[this.slidingManner.cycle][i];
      } else {
        this.refs['ref' + (i - this.slideCnt + 1)].style.order = this.slidingManner.slideOrders[this.slidingManner.cycle][i];
      }
    }
  };

  CarouselSlider.prototype.movementReset = function movementReset(direction) {
    var _this5 = this;

    var interval = setInterval(function () {
      if (!_this5.slidingManner.sliding) {
        var slideCon = _this5.refs.slideCon;
        slideCon.style.transition = 'none';

        if (direction > 0) {
          slideCon.style.transform = 'translateX(-' + _this5.slidingManner.initialMovement + 'px)';
          _this5.slidingManner.movement = _this5.slidingManner.initialMovement;
        } else if (direction < 0) {
          slideCon.style.transform = 'translateX(-' + (_this5.slidingManner.movement + _this5.slidingManner.slidesTotalWidth) + 'px)';
          _this5.slidingManner.movement = _this5.slidingManner.movement + _this5.slidingManner.slidesTotalWidth;
        }

        clearInterval(interval);
      }
    }, 25);
  };

  CarouselSlider.prototype.moveSlide = function moveSlide(direction) {
    var _this6 = this;

    var expectLoadedCnt = this.mannerSetting.circular ? this.slideCnt * 3 : this.slideCnt;

    if (this.loadedCnt === expectLoadedCnt) {
      var singleMovement = 0;
      var slideCon = this.refs.slideCon;

      if (this.mannerSetting.circular) {
        this.slidingManner.sliding = true;
        slideCon.style.transition = 'transform ' + this.mannerSetting.duration + ' ease';

        if (direction === 1) {
          singleMovement = this.calMovement(direction);
          this.slidingManner.movement = this.slidingManner.movement + singleMovement;

          if (this.state.currentSlide === this.slideCnt) {
            this.setState(function (prevState) {
              return {
                currentSlide: 1
              };
            }, function () {
              slideCon.style.transform = 'translateX(-' + _this6.slidingManner.movement + 'px)';
              _this6.slidingManner.cycle = _this6.slidingManner.cycle === 2 ? 0 : _this6.slidingManner.cycle + 1;

              _this6.itemsReorder();

              _this6.movementReset(direction);
            });
          } else {
            this.setState(function (prevState) {
              return {
                currentSlide: prevState.currentSlide + 1
              };
            }, function () {
              slideCon.style.transform = 'translateX(-' + _this6.slidingManner.movement + 'px)';
            });
          }
        } else if (direction === -1) {
          singleMovement = this.calMovement(direction);
          this.slidingManner.movement = this.slidingManner.movement - singleMovement; //slideCon.style.transform = 'translateX(-' + this.slidingManner.movement + 'px)';
          //this.slidingManner.currentSlide = (this.slidingManner.currentSlide === 1) ? -1 : this.slidingManner.currentSlide - 1;

          if (this.state.currentSlide === 1) {
            this.setState(function (prevState) {
              return {
                currentSlide: _this6.slideCnt
              };
            }, function () {
              slideCon.style.transform = 'translateX(-' + _this6.slidingManner.movement + 'px)';
              _this6.slidingManner.cycle = _this6.slidingManner.cycle === 0 ? 2 : _this6.slidingManner.cycle - 1;

              _this6.itemsReorder();

              _this6.movementReset(direction);
            });
          } else {
            this.setState(function (prevState) {
              return {
                currentSlide: prevState.currentSlide - 1
              };
            }, function () {
              slideCon.style.transform = 'translateX(-' + _this6.slidingManner.movement + 'px)';
            });
          }
        }
      } else {
        slideCon.style.transition = 'transform ' + this.mannerSetting.duration + ' ease'; // for after dragging

        if (direction === 1 && this.state.currentSlide < this.slideCnt) {
          this.slidingManner.sliding = true;
          singleMovement = this.calMovement(direction);
          this.slidingManner.movement = this.slidingManner.movement + singleMovement;
          this.setState(function (prevState) {
            return {
              currentSlide: prevState.currentSlide + 1
            };
          }, function () {
            slideCon.style.transform = 'translateX(-' + _this6.slidingManner.movement + 'px)';
          });
        } else if (direction === -1 && this.state.currentSlide > 1) {
          this.slidingManner.sliding = true;
          singleMovement = this.calMovement(direction);
          this.slidingManner.movement = this.slidingManner.movement - singleMovement;
          this.setState(function (prevState) {
            return {
              currentSlide: prevState.currentSlide - 1
            };
          }, function () {
            slideCon.style.transform = 'translateX(-' + _this6.slidingManner.movement + 'px)';
          });
        } else {
          return false; //for dragging
        }
      }
    }
  };

  CarouselSlider.prototype.calMovement = function calMovement(direction) {
    var count = direction === 1 ? 1 : this.state.currentSlide === 1 ? -2 : -1;
    var movement = this.imgsWidth[this.state.currentSlide] / 2 + this.itemsMargin * 2 + this.imgsWidth[this.state.currentSlide + count] / 2;
    return movement;
  };

  CarouselSlider.prototype.handleTouchStart = function handleTouchStart(e) {
    if (this.slidingManner.sliding === false) {
      this.slidingManner.sliding = true;
      this.touchEvent.touchStartX = e.targetTouches[0].clientX;
      this.touchEvent.beingTouched = true;
    }
  };

  CarouselSlider.prototype.handleTouchMove = function handleTouchMove(e) {
    if (this.touchEvent.beingTouched) {
      this.slidingManner.sliding = true;
      this.touchEvent.touchMovement = this.touchEvent.touchStartX - e.targetTouches[0].clientX;
      var dragMovement = this.slidingManner.movement + this.touchEvent.touchMovement;
      e.currentTarget.style.transform = 'translateX(-' + dragMovement + 'px)';
    }
  };

  CarouselSlider.prototype.handleTouchEnd = function handleTouchEnd(e) {
    if (this.touchEvent.beingTouched) {
      if (Math.abs(this.touchEvent.touchStartX - e.changedTouches[0].clientX) > 20) {
        this.slidingManner.sliding = false;

        if (!this.slidingManner.sliding) {
          if (Math.abs(this.touchEvent.touchMovement) > this.dragEvent.threshold) {
            var direction = this.touchEvent.touchMovement > 0 ? 1 : -1;
            var draggable = this.moveSlide(direction);

            if (draggable === false) {
              e.currentTarget.style.transition = 'transform 0.5s ease';
              e.currentTarget.style.transform = 'translateX(-' + this.slidingManner.movement + 'px)';
            }
          } else {
            e.currentTarget.style.transition = 'transform 0.5s ease';
            e.currentTarget.style.transform = 'translateX(-' + this.slidingManner.movement + 'px)';
          }
        }

        this.touchEvent.touchStartX = 0;
        this.touchEvent.beingTouched = false;
      }
    }
  };

  CarouselSlider.prototype.handleButtonClick = function handleButtonClick(direction) {
    if (!this.slidingManner.sliding) {
      this.moveSlide(direction);
    }
  };

  CarouselSlider.prototype.handleDragStart = function handleDragStart(e) {
    if (this.slidingManner.sliding === false && this.dragEvent.dragging === false) {
      this.slidingManner.sliding = true; //prevent auto sliding

      this.dragEvent.dragging = true;
      e.currentTarget.style.transition = 'none';
      this.dragEvent.startPoint = e.clientX;
      e.dataTransfer.setDragImage(this.dragEvent.disableDragImage, 1, 1);
    }
  };

  CarouselSlider.prototype.handleDragOver = function handleDragOver(e) {
    e.dataTransfer.dropEffect = 'none'; // To eliminate green add button on chrome.

    e.dataTransfer.effectAllowed = 'none';
    e.preventDefault();

    if (this.dragEvent.dragging === true) {
      this.dragEvent.deltaX = this.dragEvent.startPoint - e.clientX;
      var dragMovement = this.slidingManner.movement + this.dragEvent.deltaX;
      e.currentTarget.style.transform = 'translateX(-' + dragMovement + 'px)';
    }
  };

  CarouselSlider.prototype.handleDragStop = function handleDragStop(e) {
    if (this.dragEvent.dragging === true) {
      if (Math.abs(this.dragEvent.deltaX) > this.dragEvent.threshold) {
        this.slidingManner.sliding = false;

        if (!this.slidingManner.sliding) {
          var direction = this.dragEvent.deltaX > 0 ? 1 : -1;
          var draggable = this.moveSlide(direction);

          if (draggable === false) {
            e.currentTarget.style.transition = 'transform 0.5s ease';
            e.currentTarget.style.transform = 'translateX(-' + this.slidingManner.movement + 'px)';
          }
        }
      } else {
        e.currentTarget.style.transition = 'transform 0.5s ease';
        e.currentTarget.style.transform = 'translateX(-' + this.slidingManner.movement + 'px)';
      }

      this.dragEvent.startPoint = 0;
      this.dragEvent.deltaX = 0;
      this.dragEvent.dragging = false;
    }
  };

  CarouselSlider.prototype.setTextBoxStyle = function setTextBoxStyle() {
    if (this.props.textBoxStyle) {
      return this.props.textBoxStyle;
    }
  };

  CarouselSlider.prototype.setItemsStyle = function setItemsStyle() {
    if (this.props.itemsStyle) {
      var cloneStyle = JSON.parse(JSON.stringify(this.props.itemsStyle));
      delete cloneStyle.height;
      /* height for slideCon */

      return Object.assign({}, this.defaultItemsStyle, cloneStyle);
    } else {
      return JSON.parse(JSON.stringify(this.defaultItemsStyle));
    }
  };

  CarouselSlider.prototype.setSlideConHeight = function setSlideConHeight() {
    if (this.props.itemsStyle) {
      return this.props.itemsStyle.height ? {
        height: this.props.itemsStyle.height
      } : {
        height: this.defaultSlideConStyle.height
      };
    } else {
      return {
        height: this.defaultSlideConStyle.height
      };
    }
  };

  CarouselSlider.prototype.setDotStyle = function setDotStyle() {
    var dotStyle = {};

    if (this.props.dotsSetting) {
      if (this.props.dotsSetting.style) {
        if (this.props.dotsSetting.style.dotSpace) {
          dotStyle.margin = "0px " + this.props.dotsSetting.style.dotSpace;
        }

        if (this.props.dotsSetting.style.dotSize) {
          dotStyle.height = this.props.dotsSetting.style.dotSize;
          dotStyle.width = this.props.dotsSetting.style.dotSize;
        }

        if (this.props.dotsSetting.style.dotColor) {
          dotStyle.background = this.props.dotsSetting.style.dotColor;
        }

        return Object.assign({}, this.defaultDotStyle, dotStyle);
      } else {
        return this.defaultDotStyle;
      }
    } else {
      return this.defaultDotStyle;
    }
  };

  CarouselSlider.prototype.setCurrentDotStyle = function setCurrentDotStyle() {
    var currDotStyle = {};

    if (this.props.dotsSetting) {
      if (this.props.dotsSetting.style) {
        if (this.props.dotsSetting.style.dotSpace) {
          currDotStyle.margin = "0px " + this.props.dotsSetting.style.dotSpace;
        }

        if (this.props.dotsSetting.style.currDotSize) {
          currDotStyle.height = this.props.dotsSetting.style.currDotSize;
          currDotStyle.width = this.props.dotsSetting.style.currDotSize;
        }

        if (this.props.dotsSetting.style.currDotColor) {
          currDotStyle.background = this.props.dotsSetting.style.currDotColor;
        }

        return Object.assign({}, this.defaultCurrDotStyle, currDotStyle);
      } else {
        return this.defaultCurrDotStyle;
      }
    } else {
      return this.defaultCurrDotStyle;
    }
  };

  CarouselSlider.prototype.detectDotsPosition = function detectDotsPosition() {
    var position = void 0; // let customDotsPosition = {};

    var dotsPosition = this.defaultDotsPosition;

    if (this.props.dotsSetting) {
      if (this.props.dotsSetting.placeOn) {
        if (dotsPosition[this.props.dotsSetting.placeOn] === false) {
          dotsPosition[this.props.dotsSetting.placeOn] = true;
        }
      }
    }

    for (var key in dotsPosition) {
      if (dotsPosition[key] === true) {
        position = key;
      }
    }

    if (position === 'beneath') {
      return {
        vertical: "beneath" // ,outOfBox: true

      };
    } else {
      if (position === 'top') {
        return {
          vertical: "top" // ,outOfBox: false

        };
      } else {
        return {
          vertical: "bottom" // ,outOfBox: false

        };
      }
    }
  };

  CarouselSlider.prototype.allocateDotsSet = function allocateDotsSet(setting) {
    var style = {};
    style = Object.assign({}, this.defaultDotsSetStyle);

    if (this.props.dotsSetting) {
      if (this.props.dotsSetting.style) {
        for (var key in this.props.dotsSetting.style) {
          if (key.includes('margin')) {
            style[key] = this.props.dotsSetting.style[key];
          }
        }
      }
    }

    switch (setting.vertical) {
      case 'top':
        style['position'] = 'absolute';
        style['right'] = '0px';
        style['left'] = '0px';
        style['top'] = '0px';
        break;

      case 'bottom':
        style['position'] = 'absolute';
        style['right'] = '0px';
        style['left'] = '0px';
        style['bottom'] = '0px';
        break;

      case 'beneath':
        break;
    }

    return style;
  };

  CarouselSlider.prototype.detectButtonPosition = function detectButtonPosition() {
    var position = [];
    var customBtnPosition = {};
    var btnPosition = this.defaultBtnPosition;

    if (this.props.buttonSetting) {
      if (this.props.buttonSetting.placeOn) {
        if (btnPosition[this.props.buttonSetting.placeOn] === false) {
          btnPosition[this.props.buttonSetting.placeOn] = true;
        }
      }
    }

    for (var key in btnPosition) {
      if (btnPosition[key] === true) {
        position = key.split('-');
      }
    }

    var outOfBox = void 0;

    if (position[1] === 'left' || position[1] === 'right' || position[1] === 'inside') {
      outOfBox = false;
    } else {
      outOfBox = true;
    }

    if (position[0] === 'middle') {
      return {
        separate: true,
        outOfBox: outOfBox,
        vertical: position[0],
        horizontal: position[1]
      };
    } else {
      return {
        separate: false,
        outOfBox: outOfBox,
        vertical: position[0],
        horizontal: position[1]
      };
    }
  };

  CarouselSlider.prototype.setRightButtonStyle = function setRightButtonStyle() {
    var btnStyle = void 0;
    btnStyle = this.defaultButtonIconStyle;

    if (this.props.buttonSetting) {
      if (this.props.buttonSetting.style) {
        if (this.props.buttonSetting.style.right) {
          btnStyle = Object.assign({}, this.defaultButtonIconStyle, this.props.buttonSetting.style.right);
        }
      }
    }

    return btnStyle;
  };

  CarouselSlider.prototype.setLeftButtonStyle = function setLeftButtonStyle() {
    var btnStyle = void 0;
    btnStyle = this.defaultButtonIconStyle;

    if (this.props.buttonSetting) {
      if (this.props.buttonSetting.style) {
        if (this.props.buttonSetting.style.left) {
          btnStyle = Object.assign({}, this.defaultButtonIconStyle, this.props.buttonSetting.style.left);
        }
      }
    }

    return btnStyle;
  };

  CarouselSlider.prototype.allocateButtonSet = function allocateButtonSet(setting) {
    var style = {};
    style = Object.assign({}, this.defaultButtonSetStyle);

    if (!setting.separate) {
      switch (setting.horizontal) {
        case 'beneath':
          break;

        case 'left':
          style['position'] = 'absolute';
          style['left'] = '0px';
          break;

        case 'right':
          style['position'] = 'absolute';
          style['right'] = '0px';
          break;
      }

      ;

      switch (setting.vertical) {
        case 'top':
          style['position'] = 'absolute';
          style['top'] = '0px';
          break;
        // case 'middle': //in separate case 
        // break;

        case 'bottom':
          if (setting.horizontal !== 'beneath') {
            style['position'] = 'absolute';
            style['bottom'] = '0px';
          }

          break;
      }
    }

    return style;
  };

  CarouselSlider.prototype.setSliderBoxStyles = function setSliderBoxStyles() {
    if (this.props.sliderBoxStyle) {
      return Object.assign({}, this.defaultSliderBoxStyle, this.props.sliderBoxStyle);
    } else {
      return this.defaultSliderBoxStyle;
    }
  };

  CarouselSlider.prototype.setHoverEvent = function setHoverEvent() {
    var hoverEffect = void 0;

    if (this.props.buttonSetting) {
      hoverEffect = this.props.buttonSetting.hoverEvent ? this.props.buttonSetting.hoverEvent : this.buttonManner.hoverEvent;

      if (hoverEffect) {
        return {
          opacity: 0
        };
      }
    }
  };

  CarouselSlider.prototype.render = function render() {
    var _this7 = this;

    var renderSlideItems = void 0,
        items = void 0,
        sflag = void 0,
        eflag = void 0,
        slideCon = void 0,
        buttons = void 0,
        leftButton = void 0,
        rightButton = void 0,
        lButtonIcon = void 0,
        rButtonIcon = void 0,
        buttonSetting = void 0,
        dotsSet = void 0,
        dotsSetting = void 0;

    if (this.slideCnt) {
      if (this.accEleSetting.button) {
        buttonSetting = this.detectButtonPosition();
        lButtonIcon = this.props.lBtnCpnt ? this.props.lBtnCpnt : React.createElement('div', {
          className: 'rcs_arrowBtn rcs_previous',
          style: this.setLeftButtonStyle()
        });
        rButtonIcon = this.props.rBtnCpnt ? this.props.rBtnCpnt : React.createElement('div', {
          className: 'rcs_arrowBtn rcs_next',
          style: this.setRightButtonStyle()
        });

        if (buttonSetting.separate) {
          leftButton = React.createElement('div', {
            className: 'rcs_buttonWrapper rcs_left',
            style: this.setHoverEvent(),
            onClick: function onClick() {
              return _this7.handleButtonClick(-1);
            }
          }, lButtonIcon);
          rightButton = React.createElement('div', {
            className: 'rcs_buttonWrapper rcs_right',
            style: this.setHoverEvent(),
            onClick: function onClick() {
              return _this7.handleButtonClick(1);
            }
          }, rButtonIcon);
        } else {
          buttons = React.createElement('div', {
            className: 'rcs_buttonSet',
            style: this.allocateButtonSet(buttonSetting)
          }, React.createElement('div', {
            className: 'rcs_buttonWrapper',
            style: this.setHoverEvent(),
            onClick: function onClick() {
              return _this7.handleButtonClick(-1);
            }
          }, lButtonIcon), React.createElement('div', {
            className: 'rcs_buttonWrapper',
            style: this.setHoverEvent(),
            onClick: function onClick() {
              return _this7.handleButtonClick(1);
            }
          }, rButtonIcon));
        }
      }

      if (this.mannerSetting.circular && this.slideCnt > 1) {
        // Ignore this.accEleSetting.flag in this scope.
        items = this.slideEls.map(function (slideEl, index) {
          return _this7.slideItemHandler(slideEl, index - _this7.slideCnt);
        });
        items = items.concat(this.slideEls.map(function (slideEl, index) {
          return _this7.slideItemHandler(slideEl, index + 1);
        }));
        items = items.concat(this.slideEls.map(function (slideEl, index) {
          return _this7.slideItemHandler(slideEl, index + 1 + _this7.slideCnt);
        }));
      } else {
        if (this.accEleSetting.flag) {
          sflag = React.createElement('div', {
            className: 'rcs_flag',
            ref: 'sflag',
            style: {
              order: 0
            },
            key: 'sflag'
          });
          eflag = React.createElement('div', {
            className: 'rcs_flag',
            ref: 'eflag',
            style: {
              order: this.slideCnt + 1
            },
            key: 'eflag'
          });
        } else {
          sflag = React.createElement('div', {
            className: 'rcs_flag',
            ref: 'sflag',
            style: {
              background: "transparent",
              order: 0
            },
            key: 'sflag'
          });
          eflag = React.createElement('div', {
            className: 'rcs_flag',
            ref: 'eflag',
            style: {
              background: "transparent",
              order: this.slideCnt + 1
            },
            key: 'eflag'
          });
        }

        items = this.slideEls.map(function (slideEl, index) {
          return _this7.slideItemHandler(slideEl, index + 1);
        });
        items.unshift(sflag);
        items.push(eflag);
      }
      /*Use margin to tune the button position*/


      slideCon = this.mobileDetect() ? React.createElement('div', {
        className: 'rcs_slideCon',
        ref: 'slideCon',
        style: this.setSlideConHeight(),
        onTouchStart: function onTouchStart(e) {
          return _this7.handleTouchStart(e);
        },
        onTouchMove: function onTouchMove(e) {
          return _this7.handleTouchMove(e);
        },
        onTouchEnd: function onTouchEnd(e) {
          return _this7.handleTouchEnd(e);
        }
      }, items) : React.createElement('div', {
        className: 'rcs_slideCon',
        ref: 'slideCon',
        onDragStart: function onDragStart(e) {
          return _this7.handleDragStart(e);
        },
        onDragEnd: function onDragEnd(e) {
          return _this7.handleDragStop(e);
        },
        onDragOver: function onDragOver(e) {
          return _this7.handleDragOver(e);
        },
        style: this.setSlideConHeight()
      }, items);

      if (this.accEleSetting.dots) {
        dotsSetting = this.detectDotsPosition();
        var dots = [];

        for (var i = 0; i < this.slideCnt; i++) {
          var dot = void 0;

          if (i + 1 === this.state.currentSlide) {
            dot = React.createElement('div', {
              key: 'dot' + i,
              style: this.setCurrentDotStyle()
            });
          } else {
            dot = React.createElement('div', {
              key: 'dot' + i,
              style: this.setDotStyle()
            });
          }

          dots.push(dot);
        }

        dotsSet = React.createElement('div', {
          className: 'rcs_dotsSet',
          style: this.allocateDotsSet(dotsSetting)
        }, dots);
      }

      if (this.accEleSetting.button) {
        if (this.accEleSetting.dots) {
          renderSlideItems = React.createElement('div', {
            className: 'rcs_sliderSet'
          }, buttonSetting.outOfBox ? buttonSetting.separate ? leftButton : null : null, React.createElement('div', {
            className: 'rcs_sliderBox',
            ref: 'sliderBox',
            style: this.setSliderBoxStyles()
          }, buttonSetting.outOfBox ? null : buttonSetting.separate ? leftButton : buttons, dotsSetting.vertical !== 'beneath' ? dotsSet : null, slideCon, buttonSetting.outOfBox ? null : buttonSetting.separate ? rightButton : null), dotsSetting.vertical === 'beneath' ? dotsSet : null, buttonSetting.outOfBox ? buttonSetting.separate ? rightButton : buttons : null);
        } else {
          renderSlideItems = React.createElement('div', {
            className: 'rcs_sliderSet'
          }, buttonSetting.outOfBox ? buttonSetting.separate ? leftButton : null : null, React.createElement('div', {
            className: 'rcs_sliderBox',
            ref: 'sliderBox',
            style: this.setSliderBoxStyles()
          }, buttonSetting.outOfBox ? null : buttonSetting.separate ? leftButton : buttons, slideCon, buttonSetting.outOfBox ? null : buttonSetting.separate ? rightButton : null), buttonSetting.outOfBox ? buttonSetting.separate ? rightButton : buttons : null);
        }
      } else {
        if (this.accEleSetting.dots) {
          renderSlideItems = React.createElement('div', {
            className: 'rcs_sliderSet'
          }, React.createElement('div', {
            className: 'rcs_sliderBox',
            ref: 'sliderBox',
            style: this.setSliderBoxStyles()
          }, slideCon));
        } else {
          renderSlideItems = React.createElement('div', {
            className: 'rcs_sliderSet'
          }, React.createElement('div', {
            className: 'rcs_sliderBox',
            ref: 'sliderBox',
            style: this.setSliderBoxStyles()
          }, dotsSetting.vertical !== 'beneath' ? dotsSet : null, slideCon), dotsSetting.vertical === 'beneath' ? dotsSet : null);
        }
      }
    }

    return renderSlideItems;
  };

  return CarouselSlider;
}(Component);

CarouselSlider.propTypes = {
  slideItems: PropTypes.arrayOf(function (propValue, key, componentName, location, propFullName) {
    if (!propValue[key].hasOwnProperty('imgSrc')) {
      console.log(key);
      return new Error('Fail validation at component \'' + componentName + '\', object with property \'imgSrc\' is \n                required while using prop \'slideItems\'.');
    }
  }),
  slideCpnts: PropTypes.arrayOf(PropTypes.element),
  manner: PropTypes.shape({
    autoSliding: PropTypes.object,
    circular: PropTypes.bool,
    duration: PropTypes.string
  }),
  accEle: PropTypes.shape({
    button: PropTypes.bool,
    dots: PropTypes.bool,
    flag: PropTypes.bool
  }),
  dotsSetting: PropTypes.shape({
    placeOn: PropTypes.oneOf(['top', 'bottom', 'beneath']),
    style: PropTypes.shape({
      dotSpace: PropTypes.string,
      dotSize: PropTypes.string,
      dotColor: PropTypes.string,
      currDotSize: PropTypes.string,
      currDotColor: PropTypes.string,
      marginTop: PropTypes.string,
      marginBottom: PropTypes.string
    })
  }),
  buttonSetting: PropTypes.shape({
    placeOn: PropTypes.oneOf(['top-left', 'top-right', 'middle-inside', 'middle-outside', 'bottom-left', 'bottom-right', 'bottom-beneath']),
    hoverEvent: PropTypes.bool,
    style: PropTypes.shape({
      left: PropTypes.shape({
        color: PropTypes.string,
        background: PropTypes.string,
        height: PropTypes.string,
        width: PropTypes.string,
        margin: PropTypes.string,
        fontSize: PropTypes.string,
        borderRadius: PropTypes.string,
        border: PropTypes.string
      }),
      right: PropTypes.shape({
        color: PropTypes.string,
        background: PropTypes.string,
        height: PropTypes.string,
        width: PropTypes.string,
        margin: PropTypes.string,
        fontSize: PropTypes.string,
        borderRadius: PropTypes.string,
        border: PropTypes.string
      })
    })
  }),
  lBtnCpnt: PropTypes.element,
  rBtnCpnt: PropTypes.element,
  sliderBoxStyle: PropTypes.shape({
    height: PropTypes.string,
    width: PropTypes.string,
    background: PropTypes.string,
    border: PropTypes.string
  }),
  itemsStyle: PropTypes.shape({
    height: PropTypes.string,
    padding: PropTypes.string,
    background: PropTypes.string,
    margin: PropTypes.string,
    minWidth: PropTypes.string
  }),
  textBoxStyle: PropTypes.shape({
    color: PropTypes.string,
    padding: PropTypes.string,
    background: PropTypes.string,
    borderRadius: PropTypes.string,
    textAlign: PropTypes.string,
    width: PropTypes.string,
    top: PropTypes.string,
    fontSize: PropTypes.string,
    fontWeight: PropTypes.string
  })
};
export default CarouselSlider;